module.exports = __webpack_public_path__ + "media/Gif5.a3d2c6e4.mp4";